import React from 'react';
import { withRouter } from 'react-router-dom';

import { NavItem, NavLink } from 'reactstrap';
import HttpUtil from '../../Util/httpUtil';
import Config from '../../Util/config';

import { AlertasContext } from '../../Providers/Alertas';
import { BlockUiContext } from '../../Providers/BlockUi';

function MenuXLSX() {
	/* eslint-disable no-unused-vars */
	let onLoading;
	let showInfoMessage;
	let showSuccessMessage;
	let showWarningMessage;
	let showErrorMessage;
	/* eslint-enable no-unused-vars */

	const gerarRelatorio = () => {
		onLoading(true);
		HttpUtil.eco_POST_CONFIG(`${Config.urls.API_URL_BASE}Relatorio/Download`, null, {
			responseType: 'blob',
			headers: { Authorization: `bearer ${localStorage.getItem('AccessToken')}` },
		})
			.then(response => {
				onLoading(false);

				var a = document.createElement('a');
				document.body.appendChild(a);
				a.style = 'display: none';
				const fileURL = URL.createObjectURL(response.data);
				a.href = fileURL;
				a.download = `Relatório EcoGNRE ${new Date().toLocaleString()}.xlsx`;
				a.click();
				window.URL.revokeObjectURL(fileURL);
				document.body.removeChild(a);
			})
			.catch(() => {
				onLoading(false);
				showErrorMessage('Erro ao gerar XLSX');
			});
	};

	return (
		<>
			<AlertasContext.Consumer>
				{alertas => {
					showInfoMessage = alertas.info;
					showSuccessMessage = alertas.success;
					showWarningMessage = alertas.warning;
					showErrorMessage = alertas.error;
				}}
			</AlertasContext.Consumer>
			<BlockUiContext.Consumer>
				{blockUi => {
					onLoading = blockUi.handleLoading;
				}}
			</BlockUiContext.Consumer>

			<NavItem>
				<NavLink onClick={gerarRelatorio} className="darkblue-border-left">
					<span className="menu-icon">
						<i className="fas fa-chart-bar" />
					</span>
					<span>Emitir Relatório</span>
				</NavLink>
			</NavItem>
		</>
	);
}

export default withRouter(MenuXLSX);
